import { render, staticRenderFns } from "./ingrid-brodin.vue?vue&type=template&id=a0ded8d2&scoped=true"
import script from "./ingrid-brodin.vue?vue&type=script&lang=js"
export * from "./ingrid-brodin.vue?vue&type=script&lang=js"
import style0 from "./ingrid-brodin.vue?vue&type=style&index=0&id=a0ded8d2&prod&scoped=true&lang=css"
import style1 from "./ingrid-brodin.vue?vue&type=style&index=1&id=a0ded8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ded8d2",
  null
  
)

export default component.exports